import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/layout";
import DevDetail from "../../../components/detail/devdetail";
import "./devDetail.css";
import ContactCard from "../../../components/detail/devcontactcard";
import Devdetailtop from "../../../components/detail/devdetailtop";
import Devdetailreview from "../../../components/detail/devdetailreview";

const DevDetailpage = () => {
  const [sticky, setSticky] = useState("");

  useEffect(() => {
    console.log("hello");
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 250 ? "is-sticky" : "";
    setSticky(stickyClass);
    console.log(stickyClass);
  };

  const scrollToAgency = () => {
    let googleads = document.getElementById("Agency");
    if (googleads) {
      googleads.scrollIntoView();
    } else {
      window.location.href = "#Agency";
    }
  };

  const scrollToSkills = () => {
    let googleads = document.getElementById("Skills");
    if (googleads) {
      googleads.scrollIntoView();
    } else {
      window.location.href = "#Skills";
    }
  };

  const scrollToHighlights = () => {
    let googleads = document.getElementById("Highlights");
    if (googleads) {
      googleads.scrollIntoView();
    } else {
      window.location.href = "#Highlights";
    }
  };

  const scrollToLanguage = () => {
    let googleads = document.getElementById("Language");
    if (googleads) {
      googleads.scrollIntoView();
    } else {
      window.location.href = "#Language";
    }
  };

  const scrollToHistory = () => {
    let googleads = document.getElementById("History");
    if (googleads) {
      googleads.scrollIntoView();
    } else {
      window.location.href = "#History";
    }
  };

  const scrollToPortfolio = () => {
    let googleads = document.getElementById("Portfolio");
    if (googleads) {
      googleads.scrollIntoView();
    } else {
      window.location.href = "#Portfolio";
    }
  };

  return (
    <Layout>
      <div className='dev-detail-content'>
        <div className='container'>
          <div className={`mainu-bar ${sticky ? `sticky` : ``}`}>
            <ul>
              <li onClick={scrollToAgency}>Agency</li>
              <li onClick={scrollToSkills}>Skills</li>
              <li onClick={scrollToHighlights}>Highlights</li>
              <li onClick={scrollToLanguage}>Preferred Language</li>
              <li onClick={scrollToHistory}>Work History</li>
              <li onClick={scrollToPortfolio}>Portfolio</li>
            </ul>
          </div>

          <Devdetailtop />
          <div className='dev-detail-content-container'>
            <DevDetail />
            <ContactCard />
          </div>
          <Devdetailreview />
        </div>
      </div>
    </Layout>
  );
};

export default DevDetailpage;
